import React, { Component } from "react";
import { connect } from "react-redux";
import "./content.scss";
import smrIcon from "../../../assets/svg/smrBlue-icon.svg";
import { Link } from "react-router-dom";
import { configure_progress, gettingStartedProgress } from "../../../actions/globalAction";
import smrImg from "../../../assets/smr.png";
import { Dimmer, Loader } from "semantic-ui-react";
import { setActiveModule } from "../../../actions/sideBarActions";
class SMR extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    configureProgress = () => {
        this.props.configure_progress("social_media_response", this.props.total_fields);
        localStorage.setItem("activeModule", "Response");
        this.props.setActiveModule("Response");
    };

    render() {
        return (
            <>
                <div className="gs_content">
                    <div className="left_content">
                        <div className="gs_header">
                            <img src={smrIcon} color="#268af6" className="icon_content" />
                            <span className="content_title">Social Media Response</span>
                        </div>
                        <div className="text_content">
                            <p>{`Would you like your team to respond to queries from your customers? Would you like to see what complaints have been sent through DM’s?  Would you like to do all this in real time?`}</p>
                            <p>{`Would you like to manually or automatically assign tasks to agents and track resolution time and agent performance metrics?`}</p>

                            <p> {`This section lets you do all that and more!`}</p>
                        </div>
                        <Link to="/social-response/inbox">
                            <button className="gs_link" onClick={() => this.configureProgress()}>
                                Explore
                            </button>
                        </Link>
                    </div>
                    <div className="right_content">
                        <div id="gs_loader">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                        <iframe
                            width="320px"
                            height="200px"
                            src="https://www.youtube.com/embed/oI1O1vJ0L7I?modestbranding=1;cc_load_policy=3"
                            title=""
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                            allowFullScreen
                            onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                            className="content_video"></iframe>
                        {/* <img className="content-img" src={smrImg} width="350px" height="200px" /> */}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        configure_progress: (field, total) => dispatch(configure_progress(field, total)),
        gettingStartedProgress: () => dispatch(gettingStartedProgress()),
        setActiveModule: (data) => dispatch(setActiveModule(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SMR);
